import React from 'react'

const OverviewTab = () => {
    return (
        <li className="course-description-content">

            <h4> Description </h4>
            <p> Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
            minim laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
            quis
            nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea
            commodo
                    consequat</p>
            <p> consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet
            dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud
                    exerci</p>


            <h4> What you’ll learn </h4>
            <div className="uk-child-width-1-2@s" uk-grid="">
                <div>
                    <ul className="list-2">
                        <li>Setting up the environment </li>
                        <li>Advanced HTML Practices</li>
                        <li>Build a portfolio website</li>
                        <li>Responsive Designs</li>
                    </ul>
                </div>
                <div>
                    <ul className="list-2">
                        <li>Understand HTML Programming</li>
                        <li>Code HTML</li>
                        <li>Start building beautiful websites</li>
                    </ul>
                </div>
            </div>


            <h4> Requirements </h4>
            <ul className="list-1">
                <li>Any computer will work: Windows, macOS or Linux</li>
                <li>Basic programming HTML and CSS.</li>
                <li>Basic/Minimal understanding of JavaScript</li>
            </ul>

            <h4> Here is exactly what we cover in this course: </h4>
            <p> Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
            nibh
            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi
            enim ad
            minim laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim
            veniam,
            quis
            nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea
            commodo
                        consequat</p>

            <p> consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut
            laoreet
            dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
            nostrud
                        exerci</p>

            <p> Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
            nibh
            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi
            enim ad
            minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl
            ut
            aliquip ex ea commodo consequat. Nam liber tempor cum soluta nobis eleifend
            option
            congue nihil imperdiet doming id quod mazim placerat facer possim assum.
            Lorem
            ipsum
            dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
            tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
            minim
            veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut
            aliquip
            ex
                        ea commodo consequat.</p>


        </li>

    )
}

export default OverviewTab
